module.exports = __webpack_public_path__ + "img/v1.6bf20169.png";